module.exports = __webpack_public_path__ + "static/product-analytics-da3beb4e044fc7aca25c378e67078c05.png";